import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "install-header" }
const _hoisted_2 = { class: "app-desc" }
const _hoisted_3 = {
  key: 0,
  class: "install-body"
}
const _hoisted_4 = { class: "install-desc" }
const _hoisted_5 = {
  key: 1,
  class: "install-body"
}
const _hoisted_6 = { class: "install-desc" }
const _hoisted_7 = { class: "install-steps" }
const _hoisted_8 = {
  key: 2,
  class: "install-body"
}
const _hoisted_9 = { class: "install-desc" }
const _hoisted_10 = { class: "install-steps" }
const _hoisted_11 = { class: "ios-note" }
const _hoisted_12 = {
  key: 3,
  class: "install-body install-body--desktop"
}
const _hoisted_13 = { class: "install-desc" }
const _hoisted_14 = { class: "install-hint" }

import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { usePwaInstall } from "@/composables/usePwaInstall";

const DISMISSED_KEY = "pwa_install_dismissed";

export default /*@__PURE__*/_defineComponent({
  __name: 'InstallBanner',
  setup(__props) {

const { t } = useI18n();
const { canInstall, install, isIOS, isAndroid, isStandalone, showBanner } = usePwaInstall();

const dismissed = ref(sessionStorage.getItem(DISMISSED_KEY) === "1");

const visible = computed({
    // showBanner bypasses dismissed + platform checks (explicit user intent from login page)
    get: () => !isStandalone && (showBanner.value || (!dismissed.value && (canInstall.value || isIOS || isAndroid))),
    set: (v: boolean) => { if (!v) dismiss(); },
});

function dismiss() {
    dismissed.value = true;
    showBanner.value = false;
    sessionStorage.setItem(DISMISSED_KEY, "1");
}

async function triggerInstall() {
    await install();
    dismissed.value = true;
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_bottom_sheet = _resolveComponent("v-bottom-sheet")!

  return (_openBlock(), _createBlock(_component_v_bottom_sheet, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    persistent: false,
    "max-width": "600"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        rounded: "t-xl",
        class: "install-card"
      }, {
        default: _withCtx(() => [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "handle-bar" }, null, -1)),
          _createElementVNode("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: "/icons/icon-192.png",
              alt: "AquaScaper",
              class: "app-icon"
            }, null, -1)),
            _createElementVNode("div", null, [
              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "app-name" }, "AquaScaper", -1)),
              _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('pwa.tagline')), 1)
            ]),
            _createVNode(_component_v_btn, {
              icon: "mdi-close",
              variant: "text",
              size: "small",
              color: "grey",
              class: "ml-auto",
              onClick: dismiss
            })
          ]),
          _createVNode(_component_v_divider, { class: "mx-4" }),
          (_unref(canInstall))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('pwa.android.promptDesc')), 1),
                _createVNode(_component_v_btn, {
                  color: "#00838F",
                  rounded: "pill",
                  block: "",
                  class: "mt-2",
                  onClick: triggerInstall
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("mdi-cellphone-arrow-down", -1)
                      ]))]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('pwa.install')), 1)
                  ]),
                  _: 1
                })
              ]))
            : (_unref(isAndroid))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('pwa.android.manualDesc')), 1),
                  _createElementVNode("ol", _hoisted_7, [
                    _createElementVNode("li", null, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('pwa.android.step1')), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "step-icon" }, "⋮", -1))
                    ]),
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('pwa.android.step2')), 1),
                    _createElementVNode("li", null, _toDisplayString(_unref(t)('pwa.android.step3')), 1)
                  ])
                ]))
              : (_unref(isIOS))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('pwa.ios.desc')), 1),
                    _createElementVNode("ol", _hoisted_10, [
                      _createElementVNode("li", null, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('pwa.ios.step1')), 1),
                        _createVNode(_component_v_icon, {
                          size: "18",
                          color: "#007AFF"
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("mdi-export-variant", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", null, _toDisplayString(_unref(t)('pwa.ios.step2')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_v_icon, {
                        size: "14",
                        color: "grey"
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("mdi-information-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('pwa.ios.safariOnly')), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_v_icon, {
                      size: "52",
                      color: "#00838F",
                      class: "mb-3"
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("mdi-cellphone-link", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)('pwa.desktop.desc')), 1),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(t)('pwa.desktop.hint')), 1)
                  ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})